require('./blocks/review.less');
require('./blocks/reviews/reviews');
require('./blocks/pagination.less');
require('./blocks/faq/faq');



// WEBPACK FOOTER //
// ./faq.js